import emptyFolderStitch from './stitches/emptyFolderStitch';
import markAllAsReadStitch from './stitches/markAllAsReadStitch';
import loadMailFolders from './actions/loadMailFolders';
import showErrorMessage from './utils/showErrorMessage';
import logRootFolderNodeClick from './utils/logRootFolderNodeClick';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';
import { runAfterBootstrap } from 'owa-delayed-initialization';
// Import orchestrators so they are registered
import './orchestrators/deleteItemsStoreUpdateOrchestrator';
import './orchestrators/loadMailFolders';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "MailFolderStore" */ './lazyIndex');
});
export { loadMailFolders, logRootFolderNodeClick, showErrorMessage, };
export var lazyRenameFolder = new LazyAction(lazyModule, function (m) { return m.renameFolderFromTextField; });
export var lazyNewFolderFromTextField = new LazyAction(lazyModule, function (m) { return m.createNewFolderFromNewFolderTextField; });
export var lazyCreateNewFolder = new LazyImport(lazyModule, function (m) { return m.createNewFolder; });
export var lazyMoveFolder = new LazyAction(lazyModule, function (m) { return m.moveFolder; });
export var lazyToggleFolderTreeExpansion = new LazyAction(lazyModule, function (m) { return m.toggleFolderTreeExpansion; });
runAfterBootstrap(function () {
    // Stitches
    emptyFolderStitch();
    markAllAsReadStitch();
});
//# sourceMappingURL=index.js.map